import { css, styled } from 'styled-components';

import { DropdownItem } from '../../Dropdown';
import { Styled as StyledText } from '../../Text/styles';

type OptionProps = {
  isPlaceholder?: boolean;
};

const placeholderStyles = css`
  ${StyledText.Span} {
    color: ${({ theme }) => theme.designTokens.controlPlaceholderTextColor};
  }
`;

const DropdownOption = styled(DropdownItem)<OptionProps>`
  ${({ isPlaceholder }) => isPlaceholder && placeholderStyles};
  ${({ isPlaceholder }) =>
    isPlaceholder &&
    `
    &:hover,
    &.hover {
      cursor: default;
    }
    &:focus,
    &.focus {
      background: none;
    }
  `};
`;

const Placeholder = styled.div`
  color: ${({ theme }) => theme.designTokens.controlPlaceholderTextColor};
`;

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.designTokens.selectSimpleRadioPaddingX};
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.designTokens.selectSimpleCheckboxPaddingX};
`;

export const Styled = {
  CheckboxContainer,
  DropdownOption,
  RadioContainer,
  Placeholder,
};
